<template>
  <section class="py-4">
    <div class="row" v-if="promotion">
      <div class="col-12 col-lg-6 offset-lg-3">
        <div>
          <router-link to="/promotions" class="text-primary-link">
            {{ $t('message.promotion.title') }}
          </router-link>
          <i class="fal fa-angle-right"></i>
          {{ $t('message.promotion.detail') }}
        </div>
        <section v-if="!isExpired(promotion)">
          <div class="py-3">
            <img :src="promotion.image_xl" class="img-fluid rounded" />
          </div>
          <div class="promotion-title pb-2">{{ promotion.name }}</div>
          <div v-if="promotion.promo_code">
            <div class="text-remark pb-2">{{ $t('message.promotion.promo_code') }}:</div>
            <div class="border border-info rounded text-center text-info p-2 promotion-title position-relative">
              {{ promotion.promo_code.code }}
              <div class="position-absolute" style="top: 10px; right: 8px;">
                <a href="" class="text-info" @click.prevent="savePromoCode(promotion.promo_code)" v-clipboard:copy="promotion.promo_code.code">
                  <i class="fal fa-copy fa-lg"></i>
                </a>
              </div>
            </div>
            <div class="text-center text-remark pt-3">
              {{ $t('message.promotion.duration') }} {{ promotion.end_date | prettyOnlyDate }} {{ $t('message.promotion.only') }}
            </div>
          </div>
          <div class="pt-4" style="white-space: break-spaces;">{{ promotion.detail }}</div>
          <div class="pt-4">
            <button class="btn btn-info btn-block btn-lg" @click="showSelectServiceModal()">
              {{ $t('message.menu.book_cleaner') }}
            </button>
          </div>
        </section>
        <section class="pt-5 text-center" v-else>
          <h3>{{ $t('message.promotion.expired_promotion') }}</h3>
        </section>
      </div>
    </div>
    <div v-else>
      <loader/>
    </div>
    <select-service-modal ref="selectServiceModal" :promotion="promotion"></select-service-modal>
  </section>
</template>

<script>
  import Loader from '../loader/Loader'
  import SelectServiceModal from './SelectServiceModal'
  import moment from 'moment-timezone'
  import axios from 'axios'

  export default {
    components: {
      Loader,
      SelectServiceModal
    },
    data () {
      return {
        id: this.$route.params.id,
        promotion: null
      }
    },
    methods: {
      savePromoCode (promoCode) {
        this.$store.commit('promoCode/SET_SAVED_PROMO_CODE', promoCode)
      },
      showSelectServiceModal () {
        if (this.promotion && this.promotion.promo_code) {
          this.savePromoCode(this.promotion.promo_code)
        }
        this.$refs.selectServiceModal.openModal()
      },
      isExpired (promotion) {
        let result = false
        if (promotion && promotion.end_date) {
          const currentDate = moment().format('YYYY-MM-DD HH:mm:ss')
          result = currentDate > promotion.end_date
        }
        return result
      },
      async fetchPromotionDetail () {
        const url = `/promotions/${this.id}`
        const { data } = await axios.get(url)
        if (!data.error) {
          this.promotion = data.promotion
        }
      }
    },
    mounted () {
      this.fetchPromotionDetail()
    }
  }
</script>

<style scoped>
  .promotion-title {
    font-size: 130%;
  }
</style>


// WEBPACK FOOTER //
// src/components/promotion/PromotionDetail.vue